// templateFormCount is 0 until the ticket's template comes back from the API, so the button has to read that
// unknown count the same way it reads a single form - disabled - or it paints enabled and then disables itself
// once the fetch lands.
//
// A multi-form template is the exception: there the button opens the form dialog rather than saving what is on
// the tab, so it is offered whether or not anything has been touched.
export const isUpdateAnswersDisabled = (isFormModified: boolean, templateFormCount: number) =>
  !isFormModified && templateFormCount <= 1;
